import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Group, Box, Button, Container } from '@mantine/core';
import { IconMovie, IconTicket, IconLogout, IconChartDots } from '@tabler/icons-react';
import GSLogo from './GSLogo';

function Layout() {
    const location = useLocation();
    const navigate = useNavigate();
    const isAuthPage = location.pathname === '/';

    const handleLogout = () => {
        // Clear any storage if needed
        navigate('/');
    };

    if (isAuthPage) {
        return <Outlet />;
    }

    return (
        <Box>
            <Box
                component="header"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 60,
                    backgroundColor: 'rgba(28, 28, 30, 0.7)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Container size="xl" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Group spacing="xs" style={{ cursor: 'pointer' }} onClick={() => navigate('/movies')}>
                        <GSLogo size={40} />
                    </Group>

                    <Group>
                        <Button
                            component={Link}
                            to="/movies"
                            variant="subtle"
                            color="gray"
                            leftSection={<IconMovie size={16} />}
                            style={{ color: location.pathname === '/movies' ? '#fff' : '#86868b' }}
                        >
                            Movies
                        </Button>
                        <Button
                            component={Link}
                            to="/check-reservations"
                            variant="subtle"
                            color="gray"
                            leftSection={<IconTicket size={16} />}
                            style={{ color: location.pathname === '/check-reservations' ? '#fff' : '#86868b' }}
                        >
                            Check Reservations
                        </Button>
                        <Button
                            component={Link}
                            to="/datadog-demo"
                            variant="subtle"
                            color="grape"
                            leftSection={<IconChartDots size={16} />}
                            style={{ color: location.pathname === '/datadog-demo' ? '#632CA6' : '#86868b' }}
                        >
                            APM Demo
                        </Button>
                        <Button
                            onClick={handleLogout}
                            variant="subtle"
                            color="red"
                            leftSection={<IconLogout size={16} />}
                        >
                            Logout
                        </Button>
                    </Group>
                </Container>
            </Box>

            <Box style={{ paddingTop: 60, minHeight: '100vh', backgroundColor: '#000' }}>
                <Outlet />
            </Box>
        </Box>
    );
}

export default Layout;
